module.exports = __webpack_public_path__ + "img/antes_despues_212.d38258f0.png";